import {
  getSanitizeOptions,
  type ISanitizeOptions
} from "@frontiers-vue3/public-pages";
import DOMPurify from "dompurify";

const defaultOptions = getSanitizeOptions();

export default defineNuxtPlugin(async (nuxtApp) => {
  let sanitize;

  if (import.meta.server) {
    import("jsdom").then(({ JSDOM }) => {
      sanitize = (value: string, options: ISanitizeOptions = defaultOptions) =>
        DOMPurify(new JSDOM("").window).sanitize(value, options);
      nuxtApp.provide("sanitizeHtml", sanitize);
    });
  } else {
    sanitize = (value: string, options: ISanitizeOptions = defaultOptions) =>
      DOMPurify.sanitize(value, options);
    nuxtApp.provide("sanitizeHtml", sanitize);
  }
});
